import Accounts from "./Accounts";
import Booking from "./Booking";
import Customer from "./Customer";
import Inventory from "./Inventory";
import RestaurantSetup from "./RestaurantSetup";
import SalesPurchase from "./SalesPurchase";
import Settings from "./Settings";
import Stock from "./Stock";
import Utilities from "./Utilities";
import Vouchers from "./Vouchers";

export default {
  Inventory,
  Utilities,
  Settings,
  Stock,
  SalesPurchase,
  RestaurantSetup,
  Customer,
  Accounts,
  Booking,
  Vouchers,
};
